import classNames from 'classnames';
import * as moment from 'moment';
import ToggleSwitch from 'components/generic/toggle-switch';
import './style.scss';
import { startCase } from 'lodash';
import Images from 'assets/Images';

const CardComponent = props => {
	const { item, index, halfWidth, checkbox, handleToggle, checked, toggleOn, toggle, border, handleChecked } = props;

	// date formate
	const dateFormate = value => {
		return moment(value).format('DD-MM-YYYY');
	};

	return (
		<>
			<div className={classNames({ card__col: true, 'card__col--half': halfWidth })}>
				<div className={classNames({ card__block: true, 'card--border': border })}>
					<div className='card__wrap'>
						<div className='card__section'>
							{item?.image && (
								<div className='card__img'>
									<img src={Images[item?.image]} alt='img' />
								</div>
							)}
							<h4>
								{item?.title} {item?.version && <span className='card__section--version'>v{item?.version}</span>}
							</h4>
							<p>{item?.description}</p>
						</div>
						{checkbox && (
							<div className='card__section'>
								<input id={index} type='checkbox' onChange={e => handleChecked(e.target.checked, item)} checked={checked} />
							</div>
						)}
					</div>
					<div className='card__wrap'>
						<div className='card__section'>
							<span>{item?.updatedBy} </span>
							<span>{dateFormate(item?.updatedAt)}</span>
						</div>

						{item?.status && (
							<div className='card__section'>
								<div className={classNames({ card__status: true, 'card--publish': item?.status === 'PUBLISHED', 'card--draft': item?.status === 'DRAFT' })}>{startCase(item?.status?.toLowerCase())}</div>
							</div>
						)}
						{toggle && (
							<div className='card__section'>
								<ToggleSwitch checked={toggleOn} onChange={e => handleToggle(e, item)} />
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default CardComponent;
